
<template>
    <div class="p-fluid p-grid">
      <div class="p-col-12 p-md-6">
        <canvas id="planet-chart3"></canvas>
      </div>
      <div class="p-col-12 p-md-6">
        <canvas id="planet-chart4"></canvas>
      </div>
      <div class="p-col-12 p-md-6">
        <canvas id="planet-chart5"></canvas>
      </div>
      <div class="p-col-12 p-md-6">
        <canvas id="planet-chart7"></canvas>
      </div>
    </div>
</template>
  
<script>
import Chart from 'chart.js'

export default {
  name: 'Chart',
  data() {
    return {
      chartData: null,
      planetChartData1: null,
      planetChartData2: null
    }
  },
  mounted() {
    this.createChart()
  },
  methods: {
    createChart() {
      this.planetChartDataCashIn()
      this.planetChartDataCashOut()
      this.planetChartDataCashInOut()
    },
    async planetChartDataCashIn() {
      let resp = await this.$store.dispatch('loadCashInBar')
      const ctx2 = document.getElementById('planet-chart3')
      /* eslint-disable no-new */
      new Chart(ctx2, { type: 'bar', data: resp, options: '' })
      return resp
    },
    async planetChartDataCashInOut() {
      let resp = await this.$store.dispatch('loadCashInOutBar')
      const ctx4 = document.getElementById('planet-chart5')
      const ctx5 = document.getElementById('planet-chart7')
      /* eslint-disable no-new */
      new Chart(ctx4, { type: 'bar', data: resp, options: '' })
      new Chart(ctx5, { type: 'line', data: resp, options: '' })
      return resp
    },
    async planetChartDataCashOut() {
      let resp = await this.$store.dispatch('loadCashOutBar')
      const ctx3 = document.getElementById('planet-chart4')
      new Chart(ctx3, { type: 'bar', data: resp, options: '' })
      return resp
    }
  }
}
</script>



// WEBPACK FOOTER //
// receiptPaymentGraph.vue?74bec41f